import { VehicleDealerInfo } from './vehicle-dealer-info';
import { BasicInfo } from './basic-info';
import { Coords } from './coords';
import { PaymentInfo } from './payment-info';

/* tslint:disable */

export enum VehicleClass {
    New = 1,
    Used = 2,
    Unset = 0
}

/**
 */
export class VehicleItem {
    BPDealerInfo?: any;
    BasicInfo?: BasicInfo;
    BookComparisonValue?: number;
    BuyProgramWholesale?: number;
    CityMPG?: string;
    Coords?: Coords;
    DCInventoryID?: string;
    DealerInfo?: VehicleDealerInfo;
    Description?: string;
    DirectUrl?: string;
    DiscountPercent?: number;
    Distance?: number;
    DriveTrain: string;
    EligibleForListing?: string;
    Engine?: string;
    Equipment?: string;
    EquipmentList?: string;
    FuelType?: string;
    HighwayMPG?: string;
    InventoryId?: string;
    InventoryMinFrontGross?: string;
    InventoryStatusId?: string;
    MainExternalDocumentId?: string;
    MainThumbnailUrl?: string;
    MaxDiscount?:string;
    PaymentInfo?: PaymentInfo;
    PhotoList?: string | string[];
    Photos?: string;
    SessionId?: string;
    ShowOnWebsites?: string;
    TotalCost?: string;
    Transmission?: string;
    VehicleClass?: string | VehicleClass;
    VehicleId?: string;
    VehicleInvoicePrice?: string;
    WestlakeClassCode?: string;

}



// WEBPACK FOOTER //
// ./src/app/api/models/vehicle-item.ts